import { useTranslation } from 'react-i18next';

import { Typography } from '@packages/fenrir/components';

export const NoDataEnDash = () => {
  const { t } = useTranslation();
  return <Typography variant="body2">{t('ui:noDataEnDash')}</Typography>;
};
